import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <main className="App-main">
      <section className="App-panel">
        <p className="App-panelKicker">404</p>
        <h2>Page Not Found</h2>
        <p>This route does not exist in the React micro app.</p>
        <Link className="App-inlineLink" to="/">
          Back to Overview
        </Link>
      </section>
    </main>
  );
}

export default NotFoundPage;
